import { StaticImageRender } from "./StaticImageRender";
import { Point } from "../Point";
export class StaticHtmlImageRender extends StaticImageRender {
    constructor({ src, bbox, width, height, opacity, onLoad, onLoadStart, onLoadEnd, onDisplayed = undefined, onRemoved = undefined }) {
        super({ src, width, height, opacity, onLoad, onLoadStart, onLoadEnd });
        this.bbox = bbox;
        this.onDisplayed = onDisplayed;
        this.onRemoved = onRemoved;
    }
    contains(position) {
        let resolution = this.bbox.width / this.width;
        return this.bbox.contains(new Point([position[0] * resolution, -position[1] * resolution], this.bbox.crs));
    }
}
